import { render, staticRenderFns } from "./pause.vue?vue&type=template&id=1a2fb50d&"
import script from "./pause.vue?vue&type=script&lang=js&"
export * from "./pause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports